/* MOVTECH „Most vagy soha" landing (sections/movtech-most-vagy-soha.liquid).
   0. oldalon belüli görgetés (a téma body-ja miatt saját animációval)
   1. mély link (?kinek=sport a csoporthoz görget) és kipróbálható változatok: ?fejlec=felirat|kep, ?mobil=egymas-alatt|huzhato
      (2026-09-15 éjjel: a kategóriánkénti szűrők megszűntek). Az 1. lépés lapjai navigálnak (horgony + gorget).
   2. (megszűnt 2026-09-15: a felső lépés-sín helyett ragadós kosársáv van alul, lásd 4.)
   3. visszafogott visszaszámláló a záró sávban (nap, óra, perc; indulás előtt az indulásig)
   4. ragadós kosársáv alul (mindig látszik), mobilon kosárba tétel után kinyitja a fiókot
   7. vélemény-videók: kattintásra helyben indulnak
   8. csomag-galéria a kártyán: kockára vagy nyílra lapoz (2026-09-15 este)
   5. ?keszlet-demo=1: a tervezet kártyákon a négy készletállapot kitalált számokkal (csak előnézethez) */
(function () {
  var gyoker = document.getElementById('mvs');
  if (!gyoker) return;
  var $$ = function (sel, el) { return [].slice.call((el || gyoker).querySelectorAll(sel)); };
  /* 2026-10-19: angol oldalon angol felirat */
  var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var isRo = (document.documentElement.lang || '').toLowerCase().indexOf('ro') === 0;
  var isSk = (document.documentElement.lang || '').toLowerCase().indexOf('sk') === 0;

  /* ---------- 0. oldalon belüli görgetés ----------
     A témában a body is görgető elem, ezért a horgony-ugrás és a smooth scrollTo nem megbízható.
     Az azonnali scrollTo működik, ezért abból animálunk. A cél a rögzített lépés-sín alá kerül.
     Figyelem: a Playwright-ablakban a requestAnimationFrame le van fojtva, ott a biztosíték-időzítő viszi a célra. */
  var SIN_MAGASSAG = 12; /* 2026-09-15: a felső lépés-sín megszűnt, a cél fölött csak egy kis térköz marad */
  function gorget(cel) {
    if (!cel) return;
    var vege = Math.max(0, cel.getBoundingClientRect().top + window.scrollY - SIN_MAGASSAG);
    var eleje = window.scrollY;
    var tav = vege - eleje;
    var ugras = function (y) { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); };
    if (Math.abs(tav) < 2) return;
    if (document.hidden || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) { ugras(vege); return; }
    var ido = Math.min(600, 250 + Math.abs(tav) / 8);
    var start = null;
    var kesz = false;
    function lepes(t) {
      if (kesz) return;
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / ido);
      ugras(eleje + tav * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(lepes); else kesz = true;
    }
    requestAnimationFrame(lepes);
    /* biztosíték: ha a képkockák nem futnak (háttérbe tett lap), az idő letelte után a célra áll */
    setTimeout(function () { if (!kesz) { kesz = true; ugras(vege); } }, ido + 150);
  }
  gyoker.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || !gyoker.contains(a)) return;
    var cel = document.getElementById(a.getAttribute('href').slice(1));
    if (!cel) return;
    e.preventDefault();
    gorget(cel);
  });

  /* ---------- 1. mély link és kipróbálható változatok (Lexi, 2026-09-15 éjjel: a szűrők megszűntek) ----------
     ?kinek=sport a csoporthoz görget. ?fejlec=felirat|kep a kategória-fejlécet, ?mobil=egymas-alatt|huzhato a telefonos
     kártyasort állítja át; alapérték a szekció beállításából, a gyökér data-fejlec / data-mobil attribútumán. */
  var csoportok = $$('.mvs-csoport');
  /* szűrés csoportonként (Lexi, 2026-09-16): kinek szánod és terápia típusa (több is választható), ár (egy).
     A kártyák data-kinek / data-pillerek / data-ar attribútumából dolgozik; ha nincs találat, az üres állapot jön. */
  csoportok.forEach(function (g) {
    var gombok = $$('[data-szuro]', g);
    if (!gombok.length) return;
    var uresEl = g.querySelector('[data-ures]');
    var allapot = { kinek: [], piller: [], ar: '' };
    /* mobil szűrő-panel (Lexi, 2026-09-16): a kollekciós oldal facet-drawerének viselkedése. A panel csak
       megjelenítés, a szűrés ugyanaz, mint gépen: a gomb kattintása azonnal hat, az „Alkalmaz" csak bezár. */
    var panel = g.querySelector('[data-szuro-panel]');
    var fedes = g.querySelector('[data-szuro-fedes]');
    var nyitoGomb = g.querySelector('[data-szuro-nyit]');
    var dbEl = g.querySelector('[data-talalat-db]');
    var jelEl = g.querySelector('[data-szuro-jel]');
    function panelNyit(be) {
      if (!panel) return;
      panel.classList.toggle('mvs-szuro--nyitva', be);
      if (fedes) fedes.hidden = !be;
      if (nyitoGomb) nyitoGomb.setAttribute('aria-expanded', String(be));
      document.documentElement.classList.toggle('mvs-szuro-nyitva', be);
    }
    if (nyitoGomb) nyitoGomb.addEventListener('click', function () { panelNyit(!panel.classList.contains('mvs-szuro--nyitva')); });
    var zaroGombok = $$('[data-szuro-zar]', g);
    zaroGombok.forEach(function (b) { b.addEventListener('click', function () { panelNyit(false); }); });
    /* csoport összecsukása a címre kattintva (a kollekciós szűrő is így viselkedik); gépen a CSS letiltja a kattintást */
    var cimGombok = $$('[data-szuro-cim]', g);
    cimGombok.forEach(function (c) {
      c.addEventListener('click', function () {
        var sor = c.closest('.mvs-szurosav__sor');
        if (!sor) return;
        var csukott = sor.classList.toggle('is-csukott');
        c.setAttribute('aria-expanded', String(!csukott));
      });
    });
    if (fedes) fedes.addEventListener('click', function () { panelNyit(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panelNyit(false); });
    /* gépre váltáskor zárni kell, különben a html-en maradna a görgetés-tiltás */
    window.addEventListener('resize', function () { if (window.innerWidth > 1024) panelNyit(false); });
    function lista(k, nev) { return (k.getAttribute(nev) || '').split(' ').filter(Boolean); }
    function illik(k) {
      if (allapot.kinek.length && !allapot.kinek.some(function (x) { return lista(k, 'data-kinek').indexOf(x) > -1; })) return false;
      if (allapot.piller.length && !allapot.piller.some(function (x) { return lista(k, 'data-pillerek').indexOf(x) > -1; })) return false;
      if (allapot.ar) {
        var r = allapot.ar.split('-');
        var ar = parseInt(k.getAttribute('data-ar'), 10);
        if (isNaN(ar)) return false;
        if (r[0] && ar < Number(r[0])) return false;
        if (r[1] && ar >= Number(r[1])) return false;
      }
      return true;
    }
    /* 2026-11-04 (BN): ha akciós termékek is vannak a rácsban, a gombok darabszámát a kártyákból számoljuk újra */
    var vegyes = !!g.querySelector('.mvs-tk');
    if (vegyes) gombok.forEach(function (b) {
      var tip = b.getAttribute('data-szuro'), ert = b.getAttribute('data-ertek');
      var attr = tip === 'kinek' ? 'data-kinek' : tip === 'piller' ? 'data-pillerek' : '';
      var dbSpan = b.querySelector('.mvs-arsav__db');
      if (!attr || !dbSpan) return;
      var n = $$('.mvs-kartya', g).filter(function (k) { return lista(k, attr).indexOf(ert) > -1; }).length;
      dbSpan.textContent = '(' + n + ')';
    });
    function frissit() {
      var db = 0;
      $$('.mvs-kartya', g).forEach(function (k) { var ok = illik(k); k.hidden = !ok; if (ok) db++; });
      if (uresEl) uresEl.hidden = db > 0;
      /* 2026-11-04 (BN): a „Csomagajánlatok” / „Akciós termékek” cím csak akkor látszik, ha alatta van találat */
      $$('[data-racs-cim]', g).forEach(function (c) {
        var sel = c.getAttribute('data-racs-cim') === 'termek' ? '.mvs-kartya.mvs-tk' : '.mvs-kartya:not(.mvs-tk)';
        c.hidden = !$$(sel, g).some(function (k) { return !k.hidden; });
      });
      if (dbEl && vegyes) dbEl.textContent = db + (isEn ? (db === 1 ? ' item' : ' items') : isDe ? ' Artikel' : isRo ? ' produse' : document.documentElement.lang === 'sk' ? ' položiek' : ' termék');
      else if (dbEl) dbEl.textContent = db + (isEn ? (db === 1 ? ' package' : ' packages') : isDe ? (db === 1 ? ' Paket' : ' Pakete') : isRo ? (db === 1 ? ' pachet' : ' pachete') : isSk ? (db === 1 ? ' balík' : (db >= 2 && db <= 4) ? ' balíky' : ' balíkov') : ' csomag');
      var aktivDb = allapot.kinek.length + allapot.piller.length + (allapot.ar ? 1 : 0);
      if (jelEl) { jelEl.textContent = String(aktivDb); jelEl.hidden = aktivDb === 0; }
      gombok.forEach(function (b) {
        var tip = b.getAttribute('data-szuro');
        var ert = b.getAttribute('data-ertek');
        var be = tip === 'ar' ? allapot.ar === ert : allapot[tip].indexOf(ert) > -1;
        b.setAttribute('aria-pressed', String(be));
      });
    }
    gombok.forEach(function (b) {
      b.addEventListener('click', function () {
        var tip = b.getAttribute('data-szuro');
        var ert = b.getAttribute('data-ertek');
        if (tip === 'ar') allapot.ar = allapot.ar === ert ? '' : ert;
        else {
          var i = allapot[tip].indexOf(ert);
          if (i > -1) allapot[tip].splice(i, 1); else allapot[tip].push(ert);
        }
        frissit();
      });
    });
    $$('[data-szuro-torles]', g).forEach(function (b) {
      b.addEventListener('click', function () { allapot = { kinek: [], piller: [], ar: '' }; frissit(); });
    });
    g.mvsSzuro = function (tipus, ertek) {
      /* ha az adott szűrőgomb nincs kirajzolva (pl. a kategória szűrő ki van kapcsolva), a mély link se szűrjön (2026-09-20) */
      if (tipus !== 'ar' && !gombok.some(function (b) { return b.getAttribute('data-szuro') === tipus && b.getAttribute('data-ertek') === ertek; })) return;
      if (tipus === 'ar') allapot.ar = ertek;
      else if (allapot[tipus].indexOf(ertek) < 0) allapot[tipus].push(ertek);
      frissit();
    };
    frissit();
  });

  (function urlbol() {
    var q = new URLSearchParams(location.search);
    var fejlec = q.get('fejlec');
    var mobil = q.get('mobil');
    if (fejlec === 'felirat' || fejlec === 'kep') gyoker.setAttribute('data-fejlec', fejlec);
    if (mobil === 'egymas-alatt' || mobil === 'huzhato') gyoker.setAttribute('data-mobil', mobil);
    var kert = (q.get('kinek') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    /* ?kinek=sport: ha van ilyen csoport, oda görget; különben a „kinek szánod" szűrőt állítja be (2026-09-16) */
    var kertCsoport = csoportok.filter(function (g) { return kert.indexOf(g.dataset.csoport) > -1; })[0] || null;
    if (!kertCsoport && kert.length) csoportok.forEach(function (g) { if (g.mvsSzuro) kert.forEach(function (x) { g.mvsSzuro('kinek', x); }); });
    var piller = (q.get('piller') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (piller.length) csoportok.forEach(function (g) { if (g.mvsSzuro) piller.forEach(function (x) { g.mvsSzuro('piller', x); }); });
    if (q.get('ar')) csoportok.forEach(function (g) { if (g.mvsSzuro) g.mvsSzuro('ar', q.get('ar')); });
    if (kertCsoport) {
      setTimeout(function () {
        window.scrollTo({ top: Math.max(0, kertCsoport.getBoundingClientRect().top + window.scrollY - SIN_MAGASSAG), left: 0, behavior: 'instant' });
      }, 50);
    }
  })();

  /* ---------- 2. (a felső lépés-sín 2026-09-15-én megszűnt; helyette ragadós kosársáv alul, lásd 4.) ---------- */
  var kosarDb = parseInt(gyoker.dataset.kosarDb, 10) || 0;

  /* ---------- 3. záró sáv: visszafogott visszaszámláló (Lexi, 2026-09-15) ----------
     Napra, órára, percre, percenként frissül (nincs pörgő másodperc), mert két hónapig fut. Indulás előtt az indulásig
     számol, a kampány után „A kampány lezárult." A hero kampány-ablaka kikerült. */
  (function () {
    var el = gyoker.querySelector('[data-visszaszamlalo]');
    var kezdet = Date.parse(gyoker.dataset.kezdet);
    var veg = Date.parse(gyoker.dataset.veg);
    if (!el || isNaN(kezdet) || isNaN(veg)) return;
    var cimEl = el.querySelector('[data-visszaszamlalo-cim]');
    var idoEl = el.querySelector('[data-visszaszamlalo-ido]');
    function frissit() {
      var most = Date.now();
      if (most > veg) {
        cimEl.textContent = isEn ? 'The campaign has ended.' : isDe ? 'Die Aktion ist beendet.' : isRo ? 'Campania s-a încheiat.' : isSk ? 'Kampaň sa skončila.' : 'A kampány lezárult.';
        idoEl.textContent = '';
      } else {
        var cel = most < kezdet ? kezdet : veg;
        cimEl.textContent = most < kezdet ? (isEn ? 'Starts in:' : isDe ? 'Beginnt in:' : isRo ? 'Până la start:' : isSk ? 'Do začiatku:' : 'Indulásig:') : (isEn ? 'Campaign ends in:' : isDe ? 'Die Aktion endet in:' : isRo ? 'Până la finalul campaniei:' : isSk ? 'Do konca kampane:' : 'A kampány végéig:');
        var perc = Math.max(0, Math.floor((cel - most) / 60000));
        idoEl.textContent = isEn
          ? Math.floor(perc / 1440) + ' days ' + Math.floor((perc % 1440) / 60) + ' hours ' + (perc % 60) + ' min'
          : isDe
          ? Math.floor(perc / 1440) + (Math.floor(perc / 1440) === 1 ? ' Tag ' : ' Tage ') + Math.floor((perc % 1440) / 60) + ' Std. ' + (perc % 60) + ' Min.'
          : isRo
          ? Math.floor(perc / 1440) + (Math.floor(perc / 1440) === 1 ? ' zi ' : ' zile ') + Math.floor((perc % 1440) / 60) + (Math.floor((perc % 1440) / 60) === 1 ? ' oră ' : ' ore ') + (perc % 60) + ' min'
          : isSk
          ? Math.floor(perc / 1440) + (Math.floor(perc / 1440) === 1 ? ' deň ' : (Math.floor(perc / 1440) >= 2 && Math.floor(perc / 1440) <= 4) ? ' dni ' : ' dní ') + Math.floor((perc % 1440) / 60) + (Math.floor((perc % 1440) / 60) === 1 ? ' hodina ' : (Math.floor((perc % 1440) / 60) >= 2 && Math.floor((perc % 1440) / 60) <= 4) ? ' hodiny ' : ' hodín ') + (perc % 60) + ' min.'
          : Math.floor(perc / 1440) + ' nap ' + Math.floor((perc % 1440) / 60) + ' óra ' + (perc % 60) + ' perc';
      }
      el.hidden = false;
    }
    frissit();
    setInterval(frissit, 60000);
  })();

  /* ---------- 3.b visszaszámláló sáv a hero alatt (Lexi, 2026-09-20) ----------
     A csomag-termékoldali sáv párja: nap / óra / perc / mp, másodpercenként. A határidő a pillanatkép kampány-vége
     (data-veg), tehát valódi dátum. Lejáratkor a sáv eltűnik, nem ír ki semmit. */
  (function () {
    var sav = gyoker.querySelector('[data-mvs-ora]');
    var oraVeg = Date.parse(gyoker.dataset.veg);
    if (!sav || isNaN(oraVeg)) return;
    function ket(n) { return n < 10 ? '0' + n : String(n); }
    function ir(kulcs, ertek) {
      var el = sav.querySelector('[data-mvs-ora-ertek="' + kulcs + '"]');
      if (el) el.textContent = String(ertek);
    }
    function tikk() {
      var hatra = oraVeg - Date.now();
      if (hatra <= 0) { sav.remove(); clearInterval(oraIdozito); return; }
      var mp = Math.floor(hatra / 1000);
      ir('nap', Math.floor(mp / 86400));
      ir('ora', ket(Math.floor(mp % 86400 / 3600)));
      ir('perc', ket(Math.floor(mp % 3600 / 60)));
      ir('mp', ket(mp % 60));
    }
    tikk();
    var oraIdozito = setInterval(tikk, 1000);
  })();

  /* ---------- 4. ragadós kosársáv alul (Lexi, 2026-09-15) ----------
     Mindig látszik. Üres kosárnál „Még üres a kosarad" + a csomagokhoz visz; különben tételszám, végösszeg, és a
     gomb a kosároldalra visz (2026-09-15 késő este: „Irány a pénztár", sima link). Kosárba tételkor (nextsky:cart:added) a /cart.js-ből frissül. */
  var alsosav = gyoker.querySelector('[data-alsosav]');
  var kosarSzoveg = gyoker.querySelector('[data-kosar-szoveg]');
  var uresGomb = gyoker.querySelector('[data-kosar-ures]');
  var nyitGomb = alsosav ? alsosav.querySelector('[data-kosar-nyit]') : null;
  function kosarPenz(filler) {
    var mintaEl = gyoker.querySelector('.mvs-kartya__most');
    var minta = mintaEl ? mintaEl.textContent.trim() : '';
    var mm = /\d{1,3}(?:(\D)\d{3})*/.exec(minta);
    var s = String(Math.round(filler / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, (mm && mm[1]) || '.');
    return mm ? minta.replace(mm[0], s) : s + (isEn ? ' HUF' : ' Ft');
  }
  function kosarMutat(db, osszeg) {
    kosarDb = db;
    if (kosarSzoveg) {
      if (db > 0) {
        kosarSzoveg.textContent = '';
        var b = document.createElement('strong');
        b.textContent = db + (isEn ? (db === 1 ? ' item' : ' items') : isDe ? ' Artikel' : isRo ? (db === 1 ? ' produs' : ' produse') : isSk ? (db === 1 ? ' položka' : (db >= 2 && db <= 4) ? ' položky' : ' položiek') : ' tétel');
        kosarSzoveg.appendChild(b);
        kosarSzoveg.appendChild(document.createTextNode((isEn ? ' in your cart' : isDe ? ' in Ihrem Warenkorb' : isRo ? ' în coșul tău' : isSk ? ' vo vašom košíku' : ' a kosaradban') + (osszeg != null ? ' · ' + kosarPenz(osszeg) : '')));
      } else {
        kosarSzoveg.textContent = isEn ? 'Your cart is empty' : isDe ? 'Ihr Warenkorb ist noch leer' : isRo ? 'Coșul tău este încă gol' : isSk ? 'Váš košík je zatiaľ prázdny' : 'Még üres a kosarad';
      }
    }
    if (uresGomb) uresGomb.hidden = db > 0;
    if (nyitGomb) nyitGomb.hidden = db < 1;
  }
  function kosarIkon() {
    return window.innerWidth > 767
      ? (document.querySelector('#cart-icon-bubble') || document.querySelector('#cart-icon-bubble-mobile'))
      : (document.querySelector('#cart-icon-bubble-mobile') || document.querySelector('#cart-icon-bubble'));
  }
  /* a [data-kosar-nyit] gomb 2026-09-15 késő este óta sima link a kosároldalra, nem nyitja a fiókot */
  document.addEventListener('nextsky:cart:added', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { kosarMutat(c.item_count || 0, c.total_price); })
      .catch(function () {});
    /* mobilon a téma beállítása „message", ezért magától nem nyílna ki a fiók */
    if (window.innerWidth > 767) return;
    var fiok = document.querySelector('cart-drawer');
    if (fiok && fiok.classList.contains('active')) return;
    var ikon = kosarIkon();
    if (ikon) ikon.click();
  });

  /* ---------- 6. méret- és színválasztás a kártyán (2026-09-15) ----------
     A pillanatkép kombinációi (data-variansok) adják a csomagárat, a „külön-külön" árat, a megtakarítást és
     a tételek árát. Élő terméknél (data-elo-variansok) a változat id-je kerül a kosár-űrlapba,
     és az élő ár, elérhetőség, készlet felülírja a pillanatképet. A párosítás kulcsa az opció-értékek sora. */
  $$('.mvs-kartya').forEach(function (k) {
    var vEl = k.querySelector('[data-variansok]');
    if (!vEl) return;
    var variansok, elo = [];
    try { variansok = JSON.parse(vEl.textContent); } catch (e) { return; }
    var eEl = k.querySelector('[data-elo-variansok]');
    if (eEl) { try { elo = JSON.parse(eEl.textContent); } catch (e) { elo = []; } }
    var valasztok = $$('[data-valaszto-index]', k);
    var mostEl = k.querySelector('.mvs-kartya__most');
    /* a pénzformátum a Liquid money kimenetéből jön (pl. „257.700 Ft"), hogy a JS ugyanúgy írja;
       ár nélküli csomagnál (nincs saját csomagár) egy másik kártya árából */
    var mintaEl = mostEl || gyoker.querySelector('.mvs-kartya__most');
    var minta = mintaEl ? mintaEl.textContent.trim() : '';
    var mm = /\d{1,3}(?:(\D)\d{3})*/.exec(minta);
    function penz(n) {
      var s = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, (mm && mm[1]) || ' ');
      return mm ? minta.replace(mm[0], s) : s + (isEn ? ' HUF' : ' Ft');
    }
    function keres(lista, kulcs) {
      return lista.filter(function (x) { return (x.opciok || []).join('|') === kulcs; })[0];
    }
    var gomb = k.querySelector('product-form button[name="add"]');
    var gombSzoveg = gomb ? gomb.textContent : '';
    function valasztott() {
      return valasztok.map(function (v) {
        var b = v.querySelector('.mvs-opcio[aria-pressed="true"]');
        return b ? b.getAttribute('data-ertek') : '';
      });
    }
    function alkalmaz() {
      var opc = valasztott();
      var vd = keres(variansok, opc.join('|'));
      var ev = keres(elo, opc.join('|'));
      valasztok.forEach(function (v, i) {
        var s = v.querySelector('[data-valaszto-ertek]');
        if (s) s.textContent = opc[i];
        if (!elo.length) return;
        /* élő terméknél az az érték áthúzott, amivel (a többi választás mellett) nem rendelhető */
        $$('.mvs-opcio', v).forEach(function (b) {
          var proba = opc.slice();
          proba[i] = b.getAttribute('data-ertek');
          var x = keres(elo, proba.join('|'));
          b.toggleAttribute('data-elfogyott', !x || !x.elerheto);
        });
      });
      if (!vd) return;
      var ar = ev ? ev.ar : vd.ar;
      var oh = ev ? (ev.osszehasonlito > ev.ar ? ev.osszehasonlito : null) : vd.osszehasonlito;
      if (mostEl && ar != null) mostEl.textContent = penz(ar);
      var kulon = k.querySelector('.mvs-kartya__kulon s');
      if (kulon && oh) kulon.textContent = penz(oh);
      var megt = k.querySelector('[data-megtakaritas]');
      if (megt && oh && ar != null) megt.textContent = isEn ? 'You save ' + penz(oh - ar) : isDe ? penz(oh - ar) + ' Ersparnis' : isRo ? 'Economisești ' + penz(oh - ar) : isSk ? 'Ušetríte ' + penz(oh - ar) : penz(oh - ar) + ' megtakarítás';
      if (ar != null) k.setAttribute('data-ar', ar);
      (vd.tetelek || []).forEach(function (t, i) {
        var li = k.querySelector('[data-tetel="' + i + '"]');
        if (!li) return;
        var tAr = li.querySelector('[data-tetel-ar]');
        if (tAr && t.ar != null) tAr.textContent = penz(t.ar);
        var tCs = li.querySelector('[data-tetel-csomagar]');
        if (tCs && t.csomagar != null) tCs.textContent = penz(t.csomagar);
      });
      /* árkedvezmény (Lexi, 2026-09-15, minden csomagnál): a megtakarítás mínusz az ajándékok bolti értéke */
      var kedvEl = k.querySelector('[data-kedvezmeny-ertek]');
      if (kedvEl && oh && ar != null) {
        var ajSum = 0;
        (vd.tetelek || []).forEach(function (t, i) {
          var tli = k.querySelector('[data-tetel="' + i + '"]');
          if (tli && tli.classList.contains('mvs-tetel--ajandek') && t.ar != null) ajSum += t.ar;
        });
        var kedvOssz = oh - ar - ajSum;
        if (kedvOssz > 0) kedvEl.textContent = penz(kedvOssz);
      }
      /* az ajándék tételek összértéke a lista alatt (ha egy ajándék ára méretenként más) */
      var ajEl = k.querySelector('[data-ajandek-ertek]');
      if (ajEl) {
        var ajOssz = 0;
        (vd.tetelek || []).forEach(function (t, i) {
          var li = k.querySelector('[data-tetel="' + i + '"]');
          if (li && li.classList.contains('mvs-tetel--ajandek') && t.ar != null) ajOssz += t.ar;
        });
        if (ajOssz > 0) ajEl.textContent = penz(ajOssz);
      }
      if (!ev) return;
      var input = k.querySelector('product-form input[name="id"]');
      if (input) input.value = ev.id;
      if (gomb) {
        gomb.disabled = !ev.elerheto;
        gomb.textContent = ev.elerheto ? gombSzoveg : (isEn ? 'This variant is sold out' : isDe ? 'Diese Variante ist ausverkauft' : isRo ? 'Această variantă s-a epuizat' : isSk ? 'Tento variant je vypredaný' : 'Ez a változat elfogyott');
      }
      var kp = k.querySelector('[data-keszlet]');
      if (kp && ev.keszlet) {
        var r = String(ev.keszlet).split('|');
        kp.className = 'mvs-keszlet mvs-keszlet--' + r[0];
        kp.innerHTML = '<span class="mvs-keszlet__pont" aria-hidden="true"></span>' + (r[2] || '');
        k.setAttribute('data-allapot', r[0]);
        var utolso = k.querySelector('[data-utolso]');
        if (utolso) utolso.hidden = r[0] !== 'egy';
      }
    }
    valasztok.forEach(function (v) {
      v.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.mvs-opcio');
        if (!b) return;
        $$('.mvs-opcio', v).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        alkalmaz();
      });
    });
    alkalmaz();
  });

  /* ---------- 7. vélemény-videók: kattintásra helyben indul, vezérlőkkel; a többi megáll ---------- */
  $$('[data-video]').forEach(function (d) {
    var v = d.querySelector('video');
    var gomb = d.querySelector('.mvs-video__play');
    if (!v || !gomb) return;
    gomb.addEventListener('click', function () {
      $$('[data-video] video').forEach(function (m) { if (m !== v) m.pause(); });
      d.classList.add('is-lejatszas');
      v.controls = true;
      v.play().catch(function () {});
    });
  });

  /* ---------- 8. csomag-galéria a kártyán (Lexi, 2026-09-15 este) ----------
     A fő kép alatt a többi kép kis kockákban; kockára kattintva vagy a nyilakkal lapoz (körbe), a sáv az aktív kockát
     középre görgeti. A kép cseréje csak a src-t írja, a kártya többi része (ár, változat) érintetlen. */
  $$('[data-galeria]').forEach(function (gal) {
    var kartya = gal.closest('.mvs-kartya');
    var fo = kartya && kartya.querySelector('[data-galeria-fo]');
    var sav = gal.querySelector('[data-galeria-sav]');
    var kockak = [].slice.call(gal.querySelectorAll('[data-galeria-kep]'));
    if (!fo || !sav || kockak.length < 2) return;
    var aktiv = 0;
    function valt(i) {
      aktiv = (i + kockak.length) % kockak.length;
      var k = kockak[aktiv];
      fo.src = k.getAttribute('data-galeria-kep');
      kockak.forEach(function (x, j) {
        x.classList.toggle('is-aktiv', j === aktiv);
        if (j === aktiv) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
      });
      sav.scrollTo({ left: Math.max(0, k.offsetLeft - (sav.clientWidth - k.offsetWidth) / 2), behavior: 'smooth' });
    }
    kockak.forEach(function (k, i) { k.addEventListener('click', function () { valt(i); }); });
    var elozo = gal.querySelector('[data-galeria-elozo]');
    var kovetkezo = gal.querySelector('[data-galeria-kovetkezo]');
    if (elozo) elozo.addEventListener('click', function () { valt(aktiv - 1); });
    if (kovetkezo) kovetkezo.addEventListener('click', function () { valt(aktiv + 1); });
  });

  /* ---------- 5. készlet-demo (csak előnézet) ---------- */
  if (new URLSearchParams(location.search).get('keszlet-demo') === '1') {
    /* a feliratok a snippets/movtech-mvs-keszlet.liquid másai */
    var MINTAK = isEn ? [
      ['sok', 'In stock'],
      ['keves', 'Only 3 left in stock'],
      ['egy', 'Last one in stock'],
      ['elfogyott', 'Sold out'],
    ] : isDe ? [
      ['sok', 'Auf Lager'],
      ['keves', 'Nur noch 3 Stück auf Lager'],
      ['egy', 'Letztes Stück auf Lager'],
      ['elfogyott', 'Ausverkauft'],
    ] : isRo ? [
      ['sok', 'În stoc'],
      ['keves', 'Doar 3 buc. în stoc'],
      ['egy', 'Ultima bucată în stoc'],
      ['elfogyott', 'Stoc epuizat'],
    ] : isSk ? [
      ['sok', 'Na sklade'],
      ['keves', 'Na sklade už len 3 ks'],
      ['egy', 'Posledný kus na sklade'],
      ['elfogyott', 'Vypredané'],
    ] : [
      ['sok', 'Raktáron'],
      ['keves', 'Már csak 3 db raktáron'],
      ['egy', 'Utolsó darab raktáron'],
      ['elfogyott', 'Elfogyott'],
    ];
    var demo = gyoker.querySelector('[data-demo]');
    if (demo) demo.hidden = false;
    $$('.mvs-kartya').filter(function (k) { return k.dataset.allapot === 'nincs'; }).forEach(function (k, i) {
      var m = MINTAK[i % MINTAK.length];
      var p = k.querySelector('[data-keszlet]');
      if (!p) return;
      p.className = 'mvs-keszlet mvs-keszlet--' + m[0];
      p.innerHTML = '<span class="mvs-keszlet__pont" aria-hidden="true"></span>' + m[1];
    });
  }

})();


